/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TActualApplicationModel,
  IMappers,
  TActualApplicationResponse,
  TActualApplicationResponse_1,
  TActualApplicationResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createActualApplicationModel(): TActualApplicationModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'mortgage',
    pathApi: '/v2/actual-application/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IActualApplicationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchActualApplication<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IActualApplicationOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TActualApplicationResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createActualApplicationModel(),
    config,
  )) as FetchResponse<TActualApplicationResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TActualApplicationResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TActualApplicationResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TActualApplicationResponse>;
}
